/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_A2Inputs */

const en_viewer_faq_a2 = /** @type {(inputs: Viewer_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes! PureJSON is a Progressive Web App (PWA). Install it from your browser and use it without an internet connection.`)
};

const ko_viewer_faq_a2 = /** @type {(inputs: Viewer_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네! PureJSON은 프로그레시브 웹 앱(PWA)입니다. 브라우저에서 설치하면 인터넷 연결 없이도 사용할 수 있습니다.`)
};

const ja_viewer_faq_a2 = /** @type {(inputs: Viewer_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい！PureJSONはプログレッシブウェブアプリ（PWA）です。ブラウザからインストールすれば、インターネット接続なしで使用できます。`)
};

/**
* | output |
* | --- |
* | "Yes! PureJSON is a Progressive Web App (PWA). Install it from your browser and use it without an internet connection." |
*
* @param {Viewer_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_a2 = /** @type {((inputs?: Viewer_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_a2(inputs)
	if (locale === "ko") return ko_viewer_faq_a2(inputs)
	return ja_viewer_faq_a2(inputs)
});